import './VideosHeader.scss'

import UploadVideoButton from 'lib/components/admin/UploadVideoButton/UploadVideoButton'
import AdminContext from 'lib/context/AdminContext'
import ProductCategory, { getDisplayNameByCategory } from 'pages/Home/ProductCategory'
import SectionHeader from 'pages/Home/sections/SectionHeader'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import SearchInput from '../search/SearchInput'
import SearchResults from '../search/SearchResults'
import useSearchInput from '../search/useSearchInput'
import useSearchQuery from '../search/useSearchQuery'
import VideoType from '../VideoType'

export interface VideosHeaderProps {
  currentProductCategory: ProductCategory
  loading: boolean
  searchResults?: VideoType[]
}

export default function VideosHeader(props: VideosHeaderProps): JSX.Element {
  const { currentProductCategory, loading, searchResults } = props
  const [t] = useTranslation()
  const { showAdminControls } = useContext(AdminContext)
  const { searchInput, setSearchInput, clearSearchInput } = useSearchInput()
  const search = useSearchQuery()
  const category = getDisplayNameByCategory(t)[currentProductCategory]

  return (
    <SectionHeader className="videos-header">
      <SectionHeader.Title>{t('home.videosSection.header.title', { category })}</SectionHeader.Title>
      {showAdminControls && <UploadVideoButton />}
      <SectionHeader.Container>
        <SectionHeader.Subtitle>{t('home.videosSection.header.subtitle')}</SectionHeader.Subtitle>
        <SearchInput input={searchInput} setInput={setSearchInput} clearSearchInput={clearSearchInput} />
      </SectionHeader.Container>
      {!loading && search && <SearchResults clearSearchInput={clearSearchInput} searchResults={searchResults} />}
    </SectionHeader>
  )
}
